import React from 'react';

interface CheckProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

const Check: React.FC<CheckProps> = ({ 
  width = 24, 
  height = 24, 
  className = '', 
  color = '#333' 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 48 48" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M43 11L16.875 37L5 25.1818" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Check;
